module.exports = __webpack_public_path__ + "static/media/expand.dc9c5465.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/icons/expand.svg
// module id = 834
// module chunks = 0